window.loadedSentryIntegrations = window.loadedSentryIntegrations || [];


function filterAlreadyLoadedIntegrations(wantedIntegrations) {
  const result = [];
  for (const integration of (wantedIntegrations || [])) {
	if (!window.loadedSentryIntegrations.includes(integration.name)) {
	  window.loadedSentryIntegrations.push(integration.name);
	  result.push(integration);
	}
  }
  return result;
}


export default function getSentryConfig(Sentry) {
  const wantedIntegrations = [
	Sentry.browserTracingIntegration(),
	Sentry.extraErrorDataIntegration(),
	// Sentry.replayIntegration(),
  ];

  const thirdPartyErrorFilterIntegration = Sentry.thirdPartyErrorFilterIntegration?.({
	filterKeys: ["roh-js-app"],
	behaviour: "drop-error-if-contains-third-party-frames",
  });
  if (thirdPartyErrorFilterIntegration) {
	wantedIntegrations.push(thirdPartyErrorFilterIntegration);
  }

  const config = {
	dsn: window.SENTRY_DSN,
	integrations: filterAlreadyLoadedIntegrations(wantedIntegrations),
	environment: window.ENVIRONMENT,
	allowUrls: [new RegExp(`${window.location.origin}/`, "i"), new RegExp(`${window.STATIC_URL}`, "i")],
	ignoreErrors: [
		"Invalid site key or not loaded", 
		"recaptcha", 
		"ReferenceError: Can't find variable: gmo", 
		"Java exception was raised during method invocation"
	],
	tracesSampleRate: window.SENTRY_TRACE_SAMPLE_RATE || 1.0,
	replaysSessionSampleRate: 0.1,
	replaysOnErrorSampleRate: window.SENTRY_SAMPLE_RATE,
	beforeSend(event) {
	  try {
		const exceptionValues = event.exception.values || [{stacktrace: {frames: []}}];
		const frames = exceptionValues?.length ? (exceptionValues[0]?.stacktrace?.frames || []) : [];
		if ((frames && frames.some(frame => (frame?.filename || "").includes("recaptcha") || (frame?.abs_path || "").includes("freshchat") || (frame?.abs_path || "").includes("plyr")) || (event.location || "").includes("recaptcha")) || event?.title == "ReferenceError: Can't find variable: gmo" || (event?.location || "").includes("plyr") || (event?.location || "") == "/js/widget.js") {
		  return null;
		}
	  } catch (error) {
		console.error("Error ignoring errors", error);
	  }
	  return event;
	}
  };
  return config;
}
